<template>
    <div id="agencyAgreementDetail">
      <a-skeleton active :loading="loading" :title="false" :paragraph="{rows:10}">
      <div class="topRow" v-if='!searchOverallFlag'>
        <div v-if="editMode">
          <a-button style="margin-right:10px;" @click="cancelEdit">{{$t('baseVO.cacel')}}</a-button>
          <a-button type="primary" @click="saveEdit">{{$t('baseVO.save')}}</a-button>
        </div>
        <div v-if="!editMode  && showButtons && agencyAgreementVO.signatureId == '0'">

            <a-button @click="editEvent" style="margin-right:10px;"><pt-icon type="icon-bianji1"></pt-icon>{{$t('baseVO.edit')}}</a-button>
            <a-button @click="deleteEvent"><pt-icon type="icon-tubiao" class="editIcon"></pt-icon>{{$t('baseVO.delete')}}</a-button>


        </div>
      </div>
      <div class="mainDiv">
        <div v-if="editMode">
          <add-agency-agreement ref="addAgencyAgreement" :agencyAgreementId="agencyAgreementId" @saveSuccess="saveSuccess"></add-agency-agreement>
        </div>
        <div v-if="!editMode">
          <div class="companyInfo">
            <div class="infoRightDiv">
              <div class="nameRow">
                <div class="companyText" v-text="agencyAgreementVO.ownerName"></div>
                <div class="signUser">{{$t('agencyAgreement.signUser')}}: {{agencyAgreementVO.createUserName}}</div>
              </div>
              <div class="companyInfoRow">
                <div style="width: 250px;">
                  <span class="labelText">{{$t('agencyAgreement.agentTerm')}}:</span>
                  <span class="infoText" v-if="agencyAgreementVO.startDate != '~'">{{agencyAgreementVO.startDate}}-{{agencyAgreementVO.endDate}}</span>
                  <span class="infoText" v-else>~</span>
                </div>
                <div style="width: 200px;">
                  <span class="labelText">{{$t('agencyAgreement.signDate')}}:</span>
                  <span class="infoText">{{agencyAgreementVO.signDate}}</span>
                </div>
                <div>
                  <span class="labelText">{{$t('agencyAgreement.modal.dueTime')}}:</span>
                  <span class="infoText">{{agencyAgreementVO.dueTimeStr}}</span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="titleRow">
              <div class="circleYellow"></div>
              <div class="titleText">{{$t('agencyAgreement.agencyProject')}}</div>
            </div>
            <div class="projectsDiv">
              <div v-for="(mansion,index) in agencyAgreementVO.agencyAgreementMansionVOList" class="projectItem">
                <pt-tag size="small" :text="mansion.mansionName" color="grey" style="margin-bottom:10px;"></pt-tag>
              </div>
            </div>
          </div>
          <div>
            <div class="titleRow">
              <div class="circleYellow"></div>
              <div class="titleText">{{$t('agencyAgreement.confirmStandard')}}</div>
            </div>
            <div class="itemDiv">
              <div v-if="agencyAgreementVO.customerConfirmationCriteria != '~' || agencyAgreementVO.customerConfirmationCriteriaRemarks != '~'">
                <div class="itemTagRow">
                  <template v-for="(customerConfirmation,index) in agencyAgreementVO.customerConfirmationCriteriaList">
                    <pt-tag :text="customerConfirmation" size="small" color="grey"></pt-tag>
                  </template>
                </div>
                <div class="itemRemarksDiv" v-if="agencyAgreementVO.customerConfirmationCriteriaRemarks != '~'">
                  <div class="itemRemarksLabel">{{$t('agencyAgreement.otherRemarks')}}:</div>
                  <div class="itemRemarksText" v-text="agencyAgreementVO.customerConfirmationCriteriaRemarks"></div>
                </div>
              </div>
              <div v-else>
                <pt-empty><span slot="description"></span></pt-empty>
              </div>
            </div>
          </div>
          <div>
            <div class="titleRow">
              <div class="circleYellow"></div>
              <div class="titleText">{{$t('agencyAgreement.commissionStandard')}}</div>
            </div>
            <div class="itemDiv">
              <div v-if="agencyAgreementVO.commissionStandard != '~' || agencyAgreementVO.commissionStandardRemarks != '~'">
                <div class="itemTagRow">
                  <template v-for="(customerConfirmation,index) in agencyAgreementVO.commissionStandardList">
                    <pt-tag :text="customerConfirmation" size="small" color="grey"></pt-tag>
                  </template>
                </div>
                <div class="itemRemarksDiv" v-if="agencyAgreementVO.commissionStandardRemarks != '~'">
                  <div class="itemRemarksLabel">{{$t('agencyAgreement.otherRemarks')}}:</div>
                  <div class="itemRemarksText" v-text="agencyAgreementVO.commissionStandardRemarks"></div>
                </div>
              </div>
              <div v-else>
                <pt-empty><span slot="description"></span></pt-empty>
              </div>
            </div>
          </div>
          <div>
            <div class="titleRow">
              <div class="circleYellow"></div>
              <div class="titleText">{{$t('agencyAgreement.attention')}}</div>
            </div>
            <div class="itemDiv">
              <div v-if="agencyAgreementVO.mattersNeedingAttention != '~' || agencyAgreementVO.mattersNeedingAttentionRemarks != '~'">
                <div class="itemTagRow">
                  <template v-for="(customerConfirmation,index) in agencyAgreementVO.mattersNeedingAttentionList">
                    <pt-tag :text="customerConfirmation" size="small" color="grey"></pt-tag>
                  </template>
                </div>
                <div class="itemRemarksDiv" v-if="agencyAgreementVO && agencyAgreementVO.returnCommissionAgreementRemarks != '~' && agencyAgreementVO.mattersNeedingAttention && JSON.parse(agencyAgreementVO.mattersNeedingAttention).indexOf('return_commission_agreement') > -1">
                  <div class="itemRemarksLabel">{{$t('agencyAgreement.returnRemarks')}}:</div>
                  <div class="itemRemarksText" v-text="agencyAgreementVO.returnCommissionAgreementRemarks"></div>
                </div>
                <div class="itemRemarksDiv" v-if="agencyAgreementVO.mattersNeedingAttentionRemarks != '~'">
                  <div class="itemRemarksLabel">{{$t('agencyAgreement.otherRemarks')}}:</div>
                  <div class="itemRemarksText" v-text="agencyAgreementVO.mattersNeedingAttentionRemarks"></div>
                </div>
              </div>
              <div v-else>
                <pt-empty><span slot="description"></span></pt-empty>
              </div>
            </div>
          </div>
          <div>
            <div class="titleRow">
              <div class="circleYellow"></div>
              <div class="titleText">{{$t('agencyAgreement.files')}}</div>
            </div>
            <div class="fileDiv" v-if="agencyAgreementVO.agencyAgreementFileVOList && agencyAgreementVO.agencyAgreementFileVOList.length > 0">
              <div v-for="(item,index) in agencyAgreementVO.agencyAgreementFileVOList"  :key="index"
                   class="fileItem">
                <pt-icon type="icon-fujian2" class="fileIcon"></pt-icon>
                <div class="fileName">{{item.fileName}}</div>
                <div @click="previewFile(item)"  v-if="$util.matchPreviewType(item.fileName)" style="margin-right: 20px;">
                  <pt-icon class="delIcon" type="icon-yulancopy" :title="$t('baseVO.preview')"></pt-icon>
                </div>
                <div @click="downFile(item)">
                  <pt-icon class="delIcon" type="icon-xiazai" :title="$t('baseVO.download')"></pt-icon>
                </div>
              </div>
              </div>
            <div v-else class="fileItem empty">
                <pt-empty :description="$t('leaveRecords.tips.emptyFile')"><span slot="description">{{$t('leaveRecords.tips.emptyFile')}}</span></pt-empty>
              </div>
            </div>
          </div>
        </div>
      </a-skeleton>
    </div>
</template>

<script>
  import AddAgencyAgreement from './addAgencyAgreement'
  import agencyAgreementApi from '@/api/database/agencyAgreement'
  export default {
    name: 'agencyAgreementDetail',
    components: { AddAgencyAgreement },
    props:{
      agencyAgreementId: null,
      taskType:null,
      showButtons:{
        type:Boolean,
        default:true
      },
      searchOverallFlag:{
        type:Boolean,
        default:false
      }
    },
    data(){
      return{
        loading:false,
        editMode:false,
        filesList:[],
        agencyAgreementVO:{},//代理协议
      }
    },
    mounted(){
      this.init();
    },
    methods:{
      previewFile(file){
        this.$util.previewFile(file.fileId)
      },
      downFile(file){
        this.$util.dowLoadFile(file.fileId,file.fileName,this);
      },
      getMansionImageUrl(fileId){
        let url = this.$util.getFileUrl(fileId);
        return url;
      },
      getImageUrl(){
        let url = this.$util.getFileUrl(this.agencyAgreementVO.ownerImg);
        return url;
      },
      init(){
        this.queryDetail();
      },
      queryDetail(){
        let this_ = this
        this.loading = true
        agencyAgreementApi.selectOne(this_.agencyAgreementId).then(res=>{
          if(res.code == 1){
            this_.agencyAgreementVO = res.data;
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      editEvent(){
        this.editMode = true;
      },
      deleteEvent(){
        let _this = this
        this.$ptConfirm({
          title: this.$t('agencyAgreement.delete.title'),
          content: this.$t('agencyAgreement.delete.content'),
          okType: 'primary',
          onOk() {
            _this.execDelete()
          },
          onCancel() {

          },
        })
      },
      confrimData(){
        let _this = this
        this.$ptConfirm({
          title: "确认协议无误,修改为正式协议? ",
          content: "确认协议无误,修改为正式协议? ",
          okType: 'primary',
          onOk() {
            _this.execUpdateStatus()
          },
          onCancel() {

          },
        })
      },
      execUpdateStatus(){
        agencyAgreementApi.updateStatus(this.agencyAgreementId).then(res=>{
          if(res.code == 1){
            this.$message.success("确认成功");
            this.saveSuccess();
          }else{
            this.$message.error(res.message)
          }
        })
      },
      execDelete(){
        let this_ = this
        agencyAgreementApi.deleteById(this_.agencyAgreementId).then(res=>{
          if(res.code == 1){
            this.$message.success(this.$t('agencyAgreement.modal.deleteSuccessTip'));
            this.$emit("closeDetail");
            // this_.agencyAgreementVO = res.data;
          }else{
            this.$message.error(res.message)
          }
        })
      },
      cancelEdit(){
        this.editMode = false;
      },
      saveEdit(){
        //this.editMode = false;
        this.$refs.addAgencyAgreement.submit();
      },
      saveSuccess(){
        this.cancelEdit();
        this.queryDetail();
        this.$emit("freshAgencyAgreementList");
      }
    }
  }
</script>

<style scoped lang="less">
  #agencyAgreementDetail{
    .topRow{
      height: 50px;
      padding: 0 40px;
      background: #FAFBFC;
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
    }
    .mainDiv{
      padding: 40px;
    }
    .companyInfo{
      display: flex;
      flex-direction: row;
      margin-bottom: 20px;
      .companyLogo{
        width: 100px;
        margin-right: 30px;
        img{
          width: 100px;
          height: 70px;
        }
      }
    }
    .titleRow{
      background: #FAFBFC;
      height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 15px;
      .circleYellow{
        width: 12px;
        height: 12px;
        background: #FABE00;
        border-radius: 50%;
        margin: 0 10px;
      }
      .titleText{
        font-size: 14px;
        color: #333333;
      }
    }
    .infoRightDiv{
      display: flex;
      flex-direction: column;
      .nameRow{
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
        justify-content: space-between;
        .companyText{
          font-size: 18px;
          color: #333333;
          font-weight: bold;
          margin-right: 12px;
        }
        .signUser{
          font-size: 12px;
          color: #333333;
        }
      }
      .companyInfoRow{
        display: flex;
        flex-direction: row;
        margin-top: 20px;
        .labelText{
          font-size: 12px;
          color: #999999;
          margin-right: 10px;
        }
        infoText{
          font-size: 12px;
          color: #333333;
        }
      }
    }
    .projectsDiv{
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;
      padding: 0 0 15px 20px;
    }
    .empty {
      display: flex;
      justify-content: center;
    }
    .fileDiv{
      padding: 0 20px;
    }
    .fileItem {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 10px 0;
      border-bottom: 1px solid #E7E7E7;

      .fileIcon {
        font-size: 18px;
      }

      .fileName {
        flex: 1;
        font-size: 12px;
        color: #333333;
        margin: 0 10px;
      }

      .delIcon {
        font-size: 14px;
        cursor: pointer;
      }
    }
    .fileItem:last-child {
      border-bottom: 0px;
    }
    .itemDiv{
      padding: 10px 20px;
      .itemTagRow{
        display: flex;
        flex-direction: row;

      }
      .itemRemarksDiv{
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        .itemRemarksLabel{
          font-size: 12px;
          color: #333333;
          margin-right: 4px;
        }
        .itemRemarksText{
          flex: 1;
          font-size: 12px;
          color: #333333;
        }
      }
    }
  }
</style>